import React from 'react';
import { Image } from '@wix/design-system';
import {
  APP_ICON_DISPLAY_SIZE_PX,
  getAppIconSourceSize,
  useResizeImage,
} from '../../hooks/image-resize';

export function AppIcon({
  iconUrl,
  appName,
  className,
  size = 'small',
}: {
  iconUrl: string;
  appName: string;
  className: string;
  size?: 'small' | 'medium';
}) {
  const resizeImage = useResizeImage();
  return (
    <Image
      height={`${APP_ICON_DISPLAY_SIZE_PX[size]}px`}
      width={`${APP_ICON_DISPLAY_SIZE_PX[size]}px`}
      alt={`${appName} icon`}
      src={resizeImage({
        imageUrl: iconUrl,
        originalHeight: 974,
        originalWidth: 974,
        toHeight: getAppIconSourceSize(size),
        toWidth: getAppIconSourceSize(size),
      })}
      className={className}
    />
  );
}
